import { gql } from "@apollo/client";

export default gql`
  query getCustomerBillingAddresses($customerId: ID!){
    getCustomerBillingAddresses(customerId: $customerId){
        success
        data{
            _id
            customer
            accountingContactId
            country
            state
            city
            province
            postCode
            address1
            address2
            isCompany
            legalCompanyName
            taxOffice
            taxNumber
        }
        code
        message
    }
}
`
